import { useQuery } from '@tcs/common/hooks/useQuery';
import { useMemo } from 'react';

export interface Provider {
  id: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  phone: string;
}

interface UseProviderLookupProps {
  loading: boolean;
  data?: Provider[];
}

export const useProviderLookup = (query?: string): UseProviderLookupProps => {
  const { data: allProviders, isLoading } = useQuery<Provider[], Error>(
    '/providers',
    {
      refetchOnMount: false,
      staleTime: 60 * 60 * 1000,
      cacheTime: 60 * 60 * 1000,
    }
  );

  const filteredProviders = useMemo(() => {
    if (!allProviders || !query) {
      return;
    }

    const searchTerm = query.trim().toLowerCase();

    return allProviders.filter((provider) => {
      const searchableText = [
        provider.name,
        provider.address,
        provider.city,
        provider.state,
        provider.zipCode,
        provider.phone,
      ]
        .join(' ')
        .toLowerCase();

      return searchableText.includes(searchTerm);
    });
  }, [allProviders, query]);

  return {
    loading: isLoading,
    data: filteredProviders,
  };
};
